import packageInfo from '../../package.json';
import { Environment } from './environment.model';

export const environment: Environment = {
  appVersion: packageInfo.version,
  production: false,
  mixpanel: {
    token: '7c3e35ea32002de8d7d3382f222aabb5',
    eventNamePrefix: 'NewBindERP',
    debug: false,
  },
  api: {
    baseUrl: 'https://appqa.bind.com.mx',
  },
  intercomAppId: 'txdwcw1h'
};
